import { useLoaderStore } from "../../stores/components/loader";
import "../../css/loader.css";

const Loader = () => {
  const { isLoading } = useLoaderStore();
  return isLoading && <div className="loader"></div>;
};

export default Loader;
